import { createFileRoute } from "@tanstack/react-router";
import { InnstillingerPage } from "@/features/innstillinger/InnstillingerPage";

export const Route = createFileRoute("/_app/innstillinger")({
  component: InnstillingerPage,
  head: () => ({
    meta: [
      {
        title: "Innstillinger | Selskapsportal for fjernvarme",
      },
    ],
  }),
});
